import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class OtherForecast extends BaseEntity {
  rows?: any[];
}
